import AuctionLanding from 'apps/AuctionLanding'
import axios from 'axios'
import {
  testimonials,
  makesSYC,
  vtaFaqs,
  vtaFaqsEasy,
  socialMediaSeoTagsVTA,
  jsonLDVTA,
  branches,
  carsSold,
} from 'vars' // TODO: Remove hardcoded data
import get from 'lodash/get'
import { getCommonStaticProps } from 'commonPage'
import commonMessages from 'lang/es/common'
import sycMessages from 'lang/es/sell-your-car'
import auctionsMessages from 'lang/es/auctions'
import { safePromise } from 'utils/universal/safePromise'
import { bannersMapper } from 'mappers/sellYourCarMapper'
import { timelineAndVideoMapper, internalSectionMapper } from 'mappers/commonMapper'

export default AuctionLanding

export async function getStaticProps() {
  const commonStaticProps = await getCommonStaticProps()
  const messages = {
    ...commonMessages,
    ...sycMessages,
    ...auctionsMessages,
  }

  const VTAUrl = `${process.env.NEXT_PUBLIC_API_WORDPRESS}/acf/v3/options/vta`
  const { result: VTAResult } = await safePromise(axios(VTAUrl))
  const bannersSatelite = bannersMapper(get(VTAResult, 'data.acf.banners_satelite', []))
  const bannersNapoles = bannersMapper(get(VTAResult, 'data.acf.banners_napoles', []))

  // const internalSections = get(VTAResult, 'data.acf.internal_sections', [])
  // const internalSectionsEasy = get(VTAResult, 'data.acf.internal_sections_easy', [])

  const mainBanner = {
    title: get(VTAResult, 'data.acf.title', ''),
    subtitle: get(VTAResult, 'data.acf.subtitle', ''),
    mainImage: get(VTAResult, 'data.acf.main_image', {}),
    video_url: get(VTAResult, 'data.acf.video_url', ''),
    image_url: get(VTAResult, 'data.acf.image_url', ''),
  }

  const mainBannerEasy = {
    title: get(VTAResult, 'data.acf.title_easy', ''),
    subtitle: get(VTAResult, 'data.acf.subtitle_easy', ''),
    mainImage: get(VTAResult, 'data.acf.main_image', {}),
    video_url: get(VTAResult, 'data.acf.video_url', ''),
    image_url: get(VTAResult, 'data.acf.image_url', ''),
  }

  const url = `${process.env.NEXT_PUBLIC_API_WORDPRESS}/acf/v3/options/home`
  const { result } = await safePromise(axios(url))
  const timeline = get(result, 'data.acf.syc_timeline', {})
  const timelineEasy = get(result, 'data.acf.syc_timeline_easy', {})

  return {
    props: {
      titleMeta: 'SYC_TITLE',
      descriptionMeta: 'SYC_DESCRIPTION',
      testimonials,
      headerProps: {
        activeIndex: 6,
        showBackButton: false,
        whatsappMessage: {
          id: 'VTA_WHATSAPP_MESSAGE',
          whatsappVTA: true,
        },
        variantWhatsappPhone: 'clikauto',
      },
      mainBanner,
      mainBannerEasy,
      internalSections: internalSectionMapper([]), // internalSections
      internalSectionsEasy: internalSectionMapper([]), // internalSectionsEasy
      timeline: timelineAndVideoMapper(timeline),
      timelineEasy: timelineAndVideoMapper(timelineEasy),
      bannersSatelite,
      bannersNapoles,
      branches,
      makesSYC,
      messages,
      commonFaqs: vtaFaqs,
      commonFaqsEasy: vtaFaqsEasy,
      socialMediaTags: socialMediaSeoTagsVTA,
      jsonLDData: jsonLDVTA,
      variantPhone: 'shopping',
      carsSold,
      hideFooter: true,
      ...commonStaticProps,
    },
  }
}
